import { getShouldShowXDPAndCourseraPlusLandingPageChanges } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';
import courseraPlusExperiments from 'bundles/epic/clients/courseraPlus';

export const previewCourseraPlusAnnualWithFreeTrialTestVariant = (isDefaultLandingPage: boolean) => {
  if (!isDefaultLandingPage) {
    return 'control';
  }

  // Remove this check when rolling out annual with 7-day free trial
  // or user-based subs-forward discovery tests to all users.
  // See: https://coursera.atlassian.net/browse/MONETIZE-1320
  if (!getShouldShowXDPAndCourseraPlusLandingPageChanges()) {
    return 'control';
  }

  return courseraPlusExperiments.preview('courseraPlusAnnualWith7dayFreeTrialTest');
};
